import auth0 from 'auth0-js';
import { AUTH_CONFIG } from './../constants/auth0';
import history from '../history';
import axios from 'axios';
import  API_URL  from './../constants/server';

export default class Auth {
  userProfile;
  // requestedScopes = 'openid profile read:messages write:messages';
  fakeProfile = {
    "sub": "google-oauth2|113428671036294433095",
    "given_name": "Tom",
    "family_name": "Lee",
    "nickname": "leehc114",
    "name": "Tom Lee",
    "picture": "https://lh5.googleusercontent.com/-A6Z9MM3tHss/AAAAAAAAAAI/AAAAAAAAGKQ/_NQzRXdeylM/photo.jpg",
    "gender": "male",
    "locale": "en",
    "updated_at": "2018-03-18T22:57:09.640Z",
    "email": "leehc114@gmail.com",
    "email_verified": true
  };

  fakeAccessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik5qQkNSa0kxTmtKR056VXhNekV4TTBNd0" + 
    "5rUkJPVUZCUVRjMk1ETTNORE16UlVWQ016Z3pRUSJ9.eyJpc3MiOiJodHRwczovL3Byb" + 
    "2plY3QteHguYXUuYXV0aDAuY29tLyIsInN1YiI6Imdvb2dsZS1vYXV0aDJ8MTEzNDI4N" + 
    "jcxMDM2Mjk0NDMzMDk1IiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3QvIiwiaHR0cHM6L" + 
    "y9wcm9qZWN0LXh4LmF1LmF1dGgwLmNvbS91c2VyaW5mbyJdLCJpYXQiOjE1MjE0MTQxN" + 
    "TMsImV4cCI6MTUyMTQyMTM1MywiYXpwIjoiT2NpS0hJRXZBTnZPeUVpNE9kR2c2VE5mY" + 
    "m03LV9rVkciLCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIn0.V3O8zznjPgw4_V3wsa3kVJ7ExQF684hKVGTWx8YHnSRTlqNSYmmwe-rBYHIoF61vqW7vW6_etc88HrlKoAczmdNkTPLaval0ONtvQ5dY-fkn6Ll-fsXggQkzjcpCYetXc91o_z4WGLwaMx5a7FJfe8HVZWqUzpjMr0s7D_HbOSUiB6iFOSOdSrit0OqzfbmndBvgacWuD8QNXilClH3AA-f_O3OGWmy92MKqInQTbw8Z8E3tPhGHlG8dI15xug-ejm-CcrIpJExBE2BR" + 
    "ILzxeoHuH2JQwD8bA9vXyrZZ-ufxz9wnwEcw8_Q_zgtuD5_SlbjC4CM9_nHJfoVZRDaXFA";
  fakeIdToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik5qQkNSa0kxTmtKR056VXhNekV4TTBNd05rUkJPVUZCUVRjMk1ETTNORE16UlVWQ016Z3pRUSJ9.eyJnaXZlbl9uYW1lIjoiVG9tIiwiZmFtaWx5X25hbWUiOiJMZWUiLCJuaWNrbmFtZSI6ImxlZWhjMTE0IiwibmFtZSI6IlRvbSBMZWUiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDUuZ29vZ2xldXNlcmNvbnRlbnQuY29tLy1BNlo5TU0zdEhzcy9BQUFBQUFBQUFBSS9BQUFBQUFBQUdLUS9fTlF6UlhkZXlsTS9waG90by5qcGciLCJnZW5kZXIiOiJtYWxlIiwibG9jYWxlIjoiZW4iLCJ1cGRhdGVkX2F0IjoiMjAxOC0wMy0xOFQyMzowMjozMy43ODlaIiwiZW1haWwiOiJsZWVoYzExNEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9wcm9qZWN0LXh4LmF1LmF1dGgwLmNvbS8iLCJzdWIiOiJnb29nbGUtb2F1dGgyfDExMzQyODY3MTAzNjI5NDQzMzA5NSIsImF1ZCI6Ik9jaUtISUV2QU52T3lFaTRPZEdnNlROZmJtNy1fa1ZHIiwiaWF0IjoxNTIxNDE0MTUzLCJleHAiOjE1MjE0NTAxNTMsImF0X2hhc2giOiJ4LUZhT3U3UXBZMVhnSW1MVEFTMllBIiwibm9uY2UiOiJLaWpwSzRibVFLYnRaYnpZbmFkMlpmc1YybTF-QTNFbiJ9.bRqDhiIGxe0bhYvKJx5feTBxLBGRIPeChXE30U935NQGvL2JU6okDtt_GiSYGUYPwfrREhA--dWbLY-yQYcnvoiVcADS2S14IHHsUnz80UbXHvNO6VrKL8FKKTVcMcm5IGkKyINBwDx5jzXrf11ShEknBbuh450e1No-HT8n_rC35CcnuTdVhuU40B8XsxSm7KuE1N4SiWYalnHzwTHYcV5SfUQDgXNCn3fBmc2u81egYSOQyiHgAY0oPZhnpFNkn7T8gYPZOQLjmXcqbA1W5w5KbAUtq3AyBX3iaPZsi8DONUpPrEnEndhlTxZ4h24Gp_zuXUBX5LcsBk8ypc-RJQ";
  fakeExpireAt= "1521421358221" ;
  fakeScope = "openid profile email";

  requestedScopes = 'openid email profile ';
  
  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientId,
    redirectUri: AUTH_CONFIG.callbackUrl,
    audience: AUTH_CONFIG.apiUrl,
    responseType: 'token id_token',
    scope: this.requestedScopes
  });

  constructor() {
    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.fakeLogin = this.fakeLogin.bind(this);
    this.handleAuthentication = this.handleAuthentication.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.userHasScopes = this.userHasScopes.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.getProfile = this.getProfile.bind(this);
    this.goToHome = this.goToHome.bind(this);
    this.getProfileFake = this.getProfileFake.bind(this);
    this.loginWithCredentials = this.loginWithCredentials.bind(this);

    this.googleLogin = this.googleLogin.bind(this);
    this.passwordLogin = this.passwordLogin.bind(this);
  }

  login() {
    this.auth0.authorize();
  }

  googleLogin(){
    this.auth0.authorize({
      // connection: 'google'
    });
  }

  fakeLogin(){
    if ( process.env.REACT_APP_STAGE === 'fake'){

      localStorage.setItem('access_token', this.fakeAccessToken);
      localStorage.setItem('id_token', this.fakeIdToken);
      localStorage.setItem('expires_at', this.fakeExpireAt);
      localStorage.setItem('scopes', this.fakeScope);
      this.goToHome();

    }
  }

  passwordLogin(username, password){
    return new Promise((resolve, reject) => {

      this.auth0.login({
        realm: 'Username-Password-Authentication',
        username: username,
        password: password,
      },function(err, authResult) {
        // console.log ( 'passwordLogin ', authResult, ' ', err);
        resolve ({ message: err, result: authResult }) 
      });
      // setTimeout(() => {
      //   if(bool) {
      //     resolve('Promise resolved after 5 seconds');
      //   } else {
      //     reject('Promise rejected after 5 seconds');
      //   }
      // }, 5000);   
    });
    
   
  }


  loginWithCredentials( username, password){
    this.auth0.redirect.loginWithCredentials({
      connection: 'Username-Password-Authentication',
      username: username,
      password: password,
      scope: 'openid'
    }, function(err, authResult) {
        console.log ( 'loginWithCredentials ', authResult, ' ', err);
      // Auth tokens in the result or an error
    });
  }



  async handleAuthentication() {
    console.log('handleAuthentication');
    
    try {
      this.auth0.parseHash((err, authResult) => {
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.setSession(authResult);


          console.log( ' handle authentication ', authResult)
          this.getProfile( async (err, profile) => {
            console.log( 'token: ' , this.getAccessToken())
            
            const headers = { 'Authorization': `Bearer ${this.getAccessToken()}`}
            // const user = await axios.get(`${API_URL}/`, { headers } )

            axios.post(`${API_URL}/user`,{profile},  { headers } )
            .then(user => {
              console.log('/user success ' +user.data)
              this.goToHome();
              // this.setState({ message: response.data.message })
              
            })
            .catch(error => {
              console.log('/user error ' + error)
              this.goToHome();
              return this.setState({ message: error.message })
            });
                
          });

        } else if (err) {
          console.log(err);
          
          
          alert(`Error: ${err.error}. Check the console for further details.`);
          this.goToHome();
        }
      });

    } catch (e){
      console.log(e);
      this.goToHome();
    }
  }

  setSession(authResult) {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    // If there is a value on the `scope` param from the authResult,
    // use it to set scopes in the session for the user. Otherwise
    // use the scopes as requested. If no scopes were requested,
    // set it to nothing
    const scopes = authResult.scope || this.requestedScopes || '';

    localStorage.setItem('access_token', authResult.accessToken);
    localStorage.setItem('id_token', authResult.idToken);
    localStorage.setItem('expires_at', expiresAt);
    localStorage.setItem('scopes', JSON.stringify(scopes));

    // navigate to the home route
    // history.replace('/home');
    // window.location.reload(); 
  }

  getAccessToken() {
    const accessToken = localStorage.getItem('access_token');
    if (!accessToken) {
      throw new Error('No access token found');
    }
    return accessToken;
  }

  getProfileFake(){
    console.log (this.fakeProfile)
    return this.fakeProfile;
  }
  getProfile(cb) {

    if ( process.env.REACT_APP_STAGE === 'fake'){
      this.userProfile = this.fakeProfile;
      console.log( this.userProfile);
      return this.userProfile;

    }

    let accessToken = this.getAccessToken();
    this.auth0.client.userInfo(accessToken, (err, profile) => {
      if (profile) {
        this.userProfile = profile;
      }
      cb(err, profile);
    });

  }

  logout() {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('scopes');
    this.userProfile = null;
    // navigate to the home route
    console.log( 'logout now')
    history.push('/');
    window.location.reload(); 
  }

  isAuthenticated() {
    // console.log( 'process.env.REACT_APP_STAGE ' , process.env.REACT_APP_STAGE)
    if ( process.env.REACT_APP_STAGE === 'fake'){
      let result = localStorage.getItem('expires_at') ? true : false ;
      return result;
    }

    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
    return new Date().getTime() < expiresAt;
  }

  userHasScopes(scopes) {
    const grantedScopes = JSON.parse(localStorage.getItem('scopes')).split(' ');
    return scopes.every(scope => grantedScopes.includes(scope));
  }

  goToHome(){
    /* let it handle redirection*/ 

    history.replace('/addCampaign'); 
    window.location.reload();     
  }
}



// WEBPACK FOOTER //
// ./src/Auth/Auth.js